/* SJ 17.10: jezyk -> kraj i waluta. Wybor jezyka w naglowku (albo w pasku podpowiedzi) ustawia tez kraj
   z tym jezykiem (de -> DE/EUR, cs -> CZ/CZK...); jesli przegladarka podaje region (de-AT -> AT), to ten region.
   Tylko gdy klient nie ma wlasnego kraju: obecny kraj to PL (domyslny) albo kraj ustawiony wczesniej automatycznie
   (localStorage sj-kraj-auto). Recznie wybrany kraj/waluta (formularz kraju) wylacza automat. Powrot na polski
   po automatycznej zmianie przywraca PL. */
/* SJ 18.10 (wlasciciel): angielski = EUR -> kraj Irlandia (anglojezyczny kraj strefy euro), bez patrzenia na region
   przegladarki (en-US dalby USD, en-GB GBP). Pozostale jezyki: region z przegladarki (de-AT -> AT), potem mapa. */
var SJ_JEZYK_KRAJ = { en: 'IE', de: 'DE', cs: 'CZ', fr: 'FR', it: 'IT', es: 'ES', 'pt-PT': 'PT', pl: 'PL' };
var SJ_JEZYK_STALY = { en: true };
function sjKrajDlaJezyka(jezyk, kraje, teraz) {
  var auto = '';
  try { auto = localStorage.getItem('sj-kraj-auto') || ''; } catch (e) {}
  var zAutomatu = auto !== '' && auto === teraz;
  if (teraz !== 'PL' && !zAutomatu) return null;
  /* SJ 25.10: klient z Polski (kraj z IP) zostaje przy PL/PLN przy kazdym jezyku, takze EN */
  if (sjKrajIp() === 'PL') return zAutomatu && teraz !== 'PL' ? 'PL' : null;
  if (jezyk === 'pl') return zAutomatu && teraz !== 'PL' ? 'PL' : null;
  var baza = String(jezyk).split('-')[0].toLowerCase();
  var lista = SJ_JEZYK_STALY[jezyk] ? [] : (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
  for (var i = 0; i < lista.length; i++) {
    var cz = String(lista[i] || '').split('-');
    if (cz[0].toLowerCase() === baza && cz[1] && kraje.indexOf(cz[1].toUpperCase()) >= 0) return cz[1].toUpperCase() === teraz ? null : cz[1].toUpperCase();
  }
  var k = SJ_JEZYK_KRAJ[jezyk];
  return k && kraje.indexOf(k) >= 0 && k !== teraz ? k : null;
}
function sjPrzedZmiana(form) {
  try {
    if (form.querySelector('select[name="country_code"]')) { localStorage.removeItem('sj-kraj-auto'); return; }
    var jez = form.querySelector('select[name="locale_code"], input[name="locale_code"]');
    var pole = form.querySelector('input[name="country_code"][data-sj-kraje]');
    if (!jez || !pole) return;
    var kraje = (pole.getAttribute('data-sj-kraje') || '').split(',').filter(Boolean);
    var k = sjKrajDlaJezyka(jez.value, kraje, pole.getAttribute('data-sj-kraj') || '');
    if (!k) return;
    pole.value = k;
    pole.disabled = false;
    if (k === 'PL') localStorage.removeItem('sj-kraj-auto'); else localStorage.setItem('sj-kraj-auto', k);
  } catch (e) {}
}
window.sjPrzedZmiana = sjPrzedZmiana;
/* SJ 25.10 (wlasciciel): "podstawowy kraj dla Polakow to napewno bedzie Polska". Kraj z IP bierzemy z Shopify
   (/browsing_context_suggestions.json, raz na sesje). Wczesniej wybor EN ustawial Irlandie/EUR takze Polakom (i kasa
   pokazywala Irlandie). Klient z Polski: jezyk nie zmienia kraju, a kraj ustawiony wczesniej automatycznie (sj-kraj-auto)
   wraca na PL przy wejsciu na strone. Recznie wybrany kraj/waluta zostaje. */
function sjKrajIp() { try { return sessionStorage.getItem('sj-kraj-ip') || ''; } catch (e) { return ''; } }
(function () {
  function popraw() {
    try {
      if (sjKrajIp() !== 'PL') return;
      var auto = localStorage.getItem('sj-kraj-auto') || '';
      var teraz = (window.Shopify && window.Shopify.country) || '';
      if (!auto || !teraz || teraz === 'PL' || auto !== teraz) return;
      if (sessionStorage.getItem('sj-kraj-pl')) return;
      sessionStorage.setItem('sj-kraj-pl', '1');
      var pole = document.querySelector('form.ng-locform input[name="country_code"][data-sj-kraje]');
      if (!pole || !pole.form || (pole.getAttribute('data-sj-kraje') || '').split(',').indexOf('PL') < 0) return;
      localStorage.removeItem('sj-kraj-auto');
      pole.value = 'PL';
      pole.disabled = false;
      pole.form.submit();
    } catch (e) {}
  }
  function start() {
    if (sjKrajIp()) { popraw(); return; }
    if (typeof fetch !== 'function') return;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var k = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        try { sessionStorage.setItem('sj-kraj-ip', k ? String(k).toUpperCase() : '-'); } catch (e) {}
        popraw();
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* maks-naglowek-mega: skrypty naglowka (mega menu, szuflada, wyszukiwarka,
   podpowiedzi). Wartosci z ustawien sekcji czyta z <script type="application/json"
   data-ng-cfg> w naglowku. */
var NGCFG = function () {
  var el = document.querySelector('[data-ng-cfg]');
  try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
};
;(function () {
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/></svg>';

  /* SJ i18n: teksty z window.sjT (layout/theme.liquid, klucze sj.js.*), polski zapas gdy brak.
     Funkcja lokalna - globalna deklaracja function sjT nadpisalaby obiekt window.sjT.
     Filtr t koduje & < > " ' jako encje HTML, a te teksty ida do textContent/setAttribute,
     wiec sjT je odkodowuje (dla obecnych tekstow PL i EN bez zmian - nie maja takich znakow). */
  function sjT(k, pl) {
    var v = window.sjT && window.sjT[k];
    if (!v) return pl;
    return String(v).replace(/&(?:#(\d+)|#x([0-9a-f]+)|(amp|lt|gt|quot|apos));/gi, function (m, d, h, n) {
      if (d) return String.fromCharCode(+d);
      if (h) return String.fromCharCode(parseInt(h, 16));
      return { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" }[n.toLowerCase()];
    });
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function firstChildList(node) {
    for (var c = node.firstElementChild; c; c = c.nextElementSibling) {
      if (c.tagName === 'UL') return c;
    }
    return null;
  }

  var init = function (head) {
    if (head.getAttribute('data-ng-on') === '1') return;
    head.setAttribute('data-ng-on', '1');

    var OPEN_MS = NGCFG().open_ms;
    var CLOSE_MS = NGCFG().close_ms;
    var ALL_TXT = NGCFG().all_text;
    var ROOT_NAME = NGCFG().menu_label;
    var MARK = NGCFG().mark;

    var nav = head.querySelector('[data-ng-nav]');
    var navwrap = head.querySelector('[data-ng-navwrap]');
    var drawer = head.querySelector('[data-ng-drawer]');
    var levelsBox = head.querySelector('[data-ng-levels]');
    var titleEl = head.querySelector('[data-ng-title]');
    var backBtn = head.querySelector('[data-ng-back]');
    var searchField = head.querySelector('[data-ng-searchfield]');
    var wide = window.matchMedia('(min-width: 1024px)');

    /* ---------- megamenu na komputerze ---------- */
    var tops = nav ? nav.querySelectorAll('.mm-l1.mm-has') : [];
    var openT = null, closeT = null, swapT = null;
    /* SJ 16.10: pozycje bez wlasnej strony (panel marek "Projektanci", href="#") */
    var toggles = nav ? nav.querySelectorAll('.mm-l1.mm-has > .mm-link[data-ng-toggle]') : [];
    var openedAt = 0;

    /* SJ szybkosc3: atrybuty i klasy zmieniamy tylko, gdy naprawde sie zmieniaja. classList.add/remove
       i setAttribute z ta sama wartoscia i tak zapisuja atrybut (rekord dla MutationObserver - np.
       Microsoft Clarity analizuje kazdy taki zapis); przy kazdym przelaczeniu kategorii bylo ich 5-6 pustych. */
    function ariaSync() {
      each(toggles, function (t) {
        var v = t.parentNode.classList.contains('is-open') ? 'true' : 'false';
        if (t.getAttribute('aria-expanded') !== v) t.setAttribute('aria-expanded', v);
      });
    }

    function panelsOff() {
      each(tops, function (li) { if (li.classList.contains('is-open')) li.classList.remove('is-open'); });
      if (head.classList.contains('ng-panel-on')) head.classList.remove('ng-panel-on');
      ariaSync();
    }

    /* SJ szybkosc3: obrazki panelu wlaczamy jednym przejsciem - loading=eager ustawiamy PRZED src,
       wiec przegladarka od razu pobiera plik, a img.decode() dekoduje go w tle, zanim panel sie pokaze.
       Wczesniej po mmImgsOn druga petla zmieniala loading i ponownie wpisywala src kazdej miniatury
       (ok. 4 zmiany atrybutow i restart pobierania na obrazek, ~90 obrazkow w panelu Buty) - to byla
       glowna praca skryptu w zdarzeniu najechania (13-36 ms). Petla zostaje tylko dla obrazkow, ktore
       przyszly z prawdziwym src i loading=lazy (pelne drzewo w edytorze motywu). */
    function warm(li) {
      if (!menuReady || li.getAttribute('data-ng-warm') === '1') return;
      li.setAttribute('data-ng-warm', '1');
      mmImgsOn(li, true);
      each(li.querySelectorAll('img.mm-img'), function (img) {
        if (img.complete || img.getAttribute('loading') === 'eager') return;
        img.setAttribute('loading', 'eager');
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src);
      });
    }

    /* SJ szybkosc3: sasiednie panele (sasiad w kolejnosci pozycji z panelem) przygotowujemy w wolnej
       chwili przegladarki, po jednym panelu na requestIdleCallback. Gdy mysz przechodzi z kategorii
       na kategorie, nastepny panel ma juz pobrane i zdekodowane obrazki, a samo przelaczenie to tylko
       zmiana klas. Tylko sasiedzi - bez pobierania wszystkich ~160 miniatur przy kazdym wejsciu. */
    var topsArr = Array.prototype.slice.call(tops);
    var warmQ = [];
    var warmBusy = false;

    function idle(fn) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 700 });
      else window.setTimeout(fn, 50);
    }

    function warmStep() {
      warmBusy = false;
      var next = warmQ.shift();
      if (next) warm(next);
      if (warmQ.length) { warmBusy = true; idle(warmStep); }
    }

    function warmSoon(li) {
      if (!li || !menuReady || li.getAttribute('data-ng-warm') === '1' || warmQ.indexOf(li) > -1) return;
      warmQ.push(li);
      if (warmBusy) return;
      warmBusy = true;
      idle(warmStep);
    }

    function warmNear(li) {
      var i = topsArr.indexOf(li);
      if (i < 0) return;
      warmSoon(topsArr[i + 1]);
      warmSoon(topsArr[i - 1]);
    }

    function panelOn(li, fitted) {
      if (!menuReady) {
        whenMenu(function () { if (li.matches(':hover')) panelOn(li); });
        return;
      }
      if (!fitted) fitDrop(li);
      each(tops, function (o) { if (o !== li && o.classList.contains('is-open')) o.classList.remove('is-open'); });
      warm(li);
      if (!li.classList.contains('is-open')) li.classList.add('is-open');
      if (!head.classList.contains('ng-panel-on')) head.classList.add('ng-panel-on');
      openedAt = Date.now();
      ariaSync();
      warmNear(li);
    }

    /* Waska lista kotwiczy sie do lewej krawedzi swojej pozycji w menu.
       Przy ostatnich pozycjach wyszlaby poza ekran - wtedy wyrownujemy do prawej.
       SJ szybkosc3: geometrie czytamy PRZED zmiana klas (bez wymuszonego przeliczenia ukladu
       w srodku najechania). Lewa krawedz listy = lewa krawedz pozycji (left:0 wzgledem li),
       szerokosc listy nie zalezy od is-flip, wiec wynik jest ten sam co pomiar po zdjeciu klasy. */
    function fitDrop(li) {
      var np = li.querySelector('.mm-panel[data-layout="grid"]');
      if (!np) return;
      var right = li.getBoundingClientRect().left + np.getBoundingClientRect().width;
      np.classList.toggle('is-flip', right > (window.innerWidth || document.documentElement.clientWidth) - 8);
    }

    if (nav && tops.length) {
      nav.classList.add('is-ready');
      each(tops, function (li) {
        li.addEventListener('mouseenter', function () {
          window.clearTimeout(closeT);
          window.clearTimeout(openT);
          if (head.classList.contains('ng-panel-on')) {
            fitDrop(li);
            warm(li);
            window.clearTimeout(swapT);
            nav.classList.add('ng-swap');
            panelOn(li, true);
            swapT = window.setTimeout(function () { nav.classList.remove('ng-swap'); }, 80);
          } else {
            warm(li);
            openT = window.setTimeout(function () { panelOn(li); }, OPEN_MS);
          }
        });
        li.addEventListener('mouseleave', function () {
          window.clearTimeout(openT);
          window.clearTimeout(closeT);
          closeT = window.setTimeout(function () {
            window.clearTimeout(swapT);
            nav.classList.remove('ng-swap');
            panelsOff();
          }, CLOSE_MS);
        });
      });
      /* SJ 16.10: klikniecie w pozycje z data-ng-toggle (Projektanci) nie przenosi
         na zadna strone - tylko otwiera albo zamyka panel (tez z klawiatury i na
         dotykowym tablecie). Panel otwarty przed chwila najechaniem (< 600 ms)
         klik zostawia otwarty, zeby "najechanie + klik" nie zamykalo go od razu. */
      each(toggles, function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var li = a.parentNode;
          window.clearTimeout(openT);
          window.clearTimeout(closeT);
          if (li.classList.contains('is-open')) {
            if (Date.now() - openedAt < 600) return;
            panelsOff();
          } else {
            panelOn(li);
          }
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!head.classList.contains('ng-panel-on')) return;
        window.clearTimeout(openT);
        window.clearTimeout(closeT);
        panelsOff();
        var act = document.activeElement;
        if (act && nav.contains(act) && act.blur) act.blur();
      });
      document.addEventListener('click', function (e) {
        if (!head.classList.contains('ng-panel-on')) return;
        if (navwrap && navwrap.contains(e.target)) return;
        window.clearTimeout(openT);
        window.clearTimeout(closeT);
        panelsOff();
      });
    }

    /* ---------- kafle promocyjne w panelu ---------- */
    function promosOn() {
    var promoBox = head.querySelector('[data-ng-promos]');
    if (promoBox && nav) {
      each(promoBox.querySelectorAll('.ng-promo'), function (promo) {
        var want = (promo.getAttribute('data-ng-for') || '').replace(/[^a-z0-9\-_]/gi, '');
        var targets = [];
        if (want) {
          var one = nav.querySelector('.mm-l1[data-h="' + want + '"] > .mm-panel');
          if (one) targets.push(one);
        } else {
          each(tops, function (li) {
            var p = li.querySelector('.mm-panel');
            if (p) targets.push(p);
          });
        }
        targets.forEach(function (panel) {
          var cell = null;
          for (var c = panel.firstElementChild; c; c = c.nextElementSibling) {
            if (c.classList && c.classList.contains('ng-promo-cell')) { cell = c; break; }
          }
          if (!cell) {
            cell = document.createElement('div');
            cell.className = 'ng-promo-cell';
            panel.appendChild(cell);
          }
          cell.appendChild(promo.cloneNode(true));
        });
      });
    }
    }

    /* ---------- szyna kategorii w panelu (desktop) ---------- */
    function railsOn() {
    each(nav ? nav.querySelectorAll('.mm-panel[data-layout="rail"]') : [], function (panel) {
      var btns = panel.querySelectorAll('.mm-railbtn[data-g]');
      var groups = panel.querySelectorAll('.mm-group[data-g]');
      if (!btns.length || !groups.length) return;
      var hoverT = null;

      function show(id) {
        each(btns, function (b) { b.classList.toggle('is-on', b.getAttribute('data-g') === id); });
        each(groups, function (g) { g.classList.toggle('is-on', g.getAttribute('data-g') === id); });
      }

      each(btns, function (b) {
        var id = b.getAttribute('data-g');
        b.addEventListener('mouseenter', function () {
          window.clearTimeout(hoverT);
          hoverT = window.setTimeout(function () { show(id); }, 60);
        });
        b.addEventListener('mouseleave', function () { window.clearTimeout(hoverT); });
        b.addEventListener('focus', function () { show(id); });
      });

      var owner = panel.parentNode;
      if (owner) {
        owner.addEventListener('mouseleave', function () {
          window.clearTimeout(hoverT);
          window.setTimeout(function () {
            if (!owner.classList.contains('is-open')) show(btns[0].getAttribute('data-g'));
          }, CLOSE_MS + 80);
        });
      }
    });
    }

    /* ---------- szuflada na telefonie ---------- */
    var DRAWER_THUMBS = NGCFG().drawer_thumbs;
    var levels = [];
    var byId = {};
    var stack = [];
    var lastFocus = null;
    var built = false;

    /* Sprawdza aktywny panel szuflady i wlacza cien u gory albo u dolu,
       zaleznie od tego, w ktora strone jest jeszcze tresc do przewiniecia. */
    function cue() {
      if (!levelsBox) return;
      var pane = null;
      for (var i = 0; i < levels.length; i++) {
        if (levels[i].classList.contains('is-active')) { pane = levels[i]; break; }
      }
      if (!pane) { levelsBox.classList.remove('has-more', 'has-prev'); return; }
      levelsBox.classList.toggle('has-more', pane.scrollHeight - pane.clientHeight - pane.scrollTop > 4);
      levelsBox.classList.toggle('has-prev', pane.scrollTop > 4);
    }

    function makePane(name, parentId) {
      var ul = document.createElement('ul');
      var id = 'p' + levels.length;
      ul.className = 'ng-pane';
      ul.setAttribute('data-ng-pane', id);
      ul.setAttribute('data-ng-name', name || ROOT_NAME);
      if (parentId) ul.setAttribute('data-ng-parent', parentId);
      levels.push(ul);
      byId[id] = ul;
      ul.addEventListener('scroll', cue, { passive: true });
      levelsBox.appendChild(ul);
      return ul;
    }

    function addRow(pane, name, href, thumbEl, targetPane) {
      if (!name) return null;
      var li = document.createElement('li');
      li.className = 'ng-item';
      var thumb = thumbEl && (DRAWER_THUMBS || thumbEl.classList.contains('mm-thumb-logo')) ? thumbEl.outerHTML : '';
      var a = document.createElement('a');
      a.className = 'ng-row' + (thumb ? ' ng-row-mini' : '');
      a.setAttribute('href', href || '#');
      a.innerHTML = thumb + '<span class="ng-row-txt">' + esc(name) + '</span>' + (targetPane ? '<span class="ng-chev">' + CHEV + '</span>' : '');
      if (targetPane) {
        var pid = targetPane.getAttribute('data-ng-pane');
        a.setAttribute('data-ng-goto', pid);
        a.addEventListener('click', function (e) { e.preventDefault(); go(pid); });
      }
      li.appendChild(a);
      pane.appendChild(li);
      return li;
    }

    function addAllRow(pane, name, href) {
      if (!href || href === '#') return;
      var li = document.createElement('li');
      li.className = 'ng-item ng-item-all';
      li.innerHTML = '<a class="ng-row ng-all" href="' + esc(href) + '"><span class="ng-row-txt">' + esc(ALL_TXT + ' ' + name) + '</span></a>';
      pane.appendChild(li);
    }

    function txtOf(node) {
      var t = node.querySelector ? node.querySelector('.mm-txt') : null;
      return ((t || node).textContent || '').replace(/\s+/g, ' ').replace(/^\s|\s$/g, '');
    }

    function kidsBySel(parent, sel) {
      var out = [];
      each(parent.children, function (c) { if (c.matches && c.matches(sel)) out.push(c); });
      return out;
    }

    function buildDrawer() {
      var root = nav ? nav.querySelector('.mm-root') : null;
      if (!levelsBox || !root) return;

      var rootPane = makePane(ROOT_NAME, null);

      kidsBySel(root, '.mm-l1').forEach(function (l1) {
        var link = null;
        each(l1.children, function (c) { if (!link && c.classList && c.classList.contains('mm-link')) link = c; });
        if (!link) return;
        var name = txtOf(link);
        var href = link.getAttribute('href') || '#';
        var panel = null;
        each(l1.children, function (c) { if (!panel && c.classList && c.classList.contains('mm-panel')) panel = c; });

        if (!panel) { addRow(rootPane, name, href, null, null); return; }

        var l1Pane = makePane(name, 'p0');
        addRow(rootPane, name, href, null, l1Pane);

        var kind = panel.getAttribute('data-layout');

        if (kind === 'rail') {
          /* SJ 16.10 (telefon): grupa o tej samej nazwie co pozycja menu (Ubrania > Ubrania, Akcesoria > Akcesoria)
             nie jest osobnym poziomem - jej kategorie stoja od razu po wejsciu w pozycje; inne grupy
             (np. Najpopularniejsze marki) zostaja jako kolejny poziom pod nimi. */
          var l1lc = name.toLowerCase(), wplecione = [];
          each(panel.querySelectorAll('.mm-group[data-g]'), function (grp) {
            var gh = grp.querySelector('.mm-ghead');
            if ((gh ? txtOf(gh) : '').toLowerCase() === l1lc && grp.querySelectorAll('.mm-tile').length) wplecione.push(grp);
          });
          each(wplecione, function (grp) {
            each(grp.querySelectorAll('.mm-tile'), function (t) {
              addRow(l1Pane, txtOf(t), t.getAttribute('href'), t.querySelector('.mm-thumb'), null);
            });
          });
          each(panel.querySelectorAll('.mm-group[data-g]'), function (grp) {
            if (wplecione.indexOf(grp) >= 0) return;
            var gh = grp.querySelector('.mm-ghead');
            var gname = gh ? txtOf(gh) : '';
            var ghref = (gh && gh.tagName === 'A') ? gh.getAttribute('href') : '';
            var tiles = grp.querySelectorAll('.mm-tile');
            if (!gname) return;
            if (!tiles.length) { addRow(l1Pane, gname, ghref || href, null, null); return; }
            var gPane = makePane(gname, l1Pane.getAttribute('data-ng-pane'));
            addRow(l1Pane, gname, ghref || href, tiles[0].querySelector('.mm-thumb'), gPane);
            each(tiles, function (t) {
              addRow(gPane, txtOf(t), t.getAttribute('href'), t.querySelector('.mm-thumb'), null);
            });
            addAllRow(gPane, gname, ghref);
          });
        } else if (kind === 'brands') {
          each(panel.querySelectorAll('.mm-bcol'), function (col) {
            var hd = col.querySelector('.mm-bhead');
            var gname = hd ? txtOf(hd) : '';
            var links = col.querySelectorAll('.mm-blink');
            if (!gname || !links.length) return;
            var gPane = makePane(gname, l1Pane.getAttribute('data-ng-pane'));
            addRow(l1Pane, gname, '#', null, gPane);
            each(links, function (a) {
              /* Logo marki z panelu desktopowego (.mm-blogo-i) trafia do wiersza
                 w szufladzie jako miniatura - ten sam plik <uchwyt>-menu.*, ktory
                 zasila menu na komputerze. Bez logo wiersz zostaje bez miniatury. */
              var logo = a.querySelector('.mm-blogo-i'), th = null;
              var logoSrc = logo ? (logo.getAttribute('src') || logo.getAttribute('data-mm-src')) : '';
              if (logoSrc) {
                th = document.createElement('span'); th.className = 'mm-thumb mm-thumb-logo';
                /* SJ szybkosc: adres w data-mm-src, nie w src - przypisanie src do obrazka spoza
                   dokumentu od razu go pobiera (66 logotypow przy kazdym otwarciu szuflady).
                   Podpina go paint() przy wejsciu w panel Projektanci. */
                var im = document.createElement('img'); im.className = 'mm-img'; im.setAttribute('data-mm-src', logoSrc); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
                th.appendChild(im);
              }
              addRow(gPane, txtOf(a), a.getAttribute('href'), th, null);
            });
          });
        } else {
          each(panel.querySelectorAll('.mm-tile'), function (t) {
            addRow(l1Pane, txtOf(t), t.getAttribute('href'), t.querySelector('.mm-thumb'), null);
          });
        }

        /* "zobacz wszystko" na dole panelu, pod pozycjami. Pozycja bez wlasnej
           strony (href="#", np. Projektanci) bierze adres z "Zobacz wszystkie"
           na dole panelu desktopowego (.mm-flatall -> /pages/projektanci). */
        var allHref = href;
        if (!allHref || allHref.charAt(0) === '#') {
          var flatAll = panel.querySelector('.mm-flatall');
          allHref = flatAll ? flatAll.getAttribute('href') : '';
        }
        addAllRow(l1Pane, name, allHref);
      });

      /* SJ 26.10 (wlasciciel): waluta i jezyk zaraz pod ostatnia pozycja menu (pod kreska pod "Sklepy Stacjonarne"),
         a nie na dole szuflady. Przenosimy gotowy .ng-dloc razem z jego obsluga (zdarzenia zostaja na elementach). */
      var dloc = drawer ? drawer.querySelector('.ng-dfoot .ng-dloc') : null;
      if (dloc && dloc.firstElementChild) {
        var locLi = document.createElement('li');
        locLi.className = 'ng-item ng-item-loc';
        locLi.appendChild(dloc);
        rootPane.appendChild(locLi);
      }
      /* SJ 26.10: pod nimi "Moje konto" i napis z flaga - dol szuflady zaslanial na telefonie pasek podgladu Shopify */
      var dfoot = drawer ? drawer.querySelector('.ng-dfoot') : null;
      if (dfoot) {
        each(dfoot.querySelectorAll('.ng-dlinks, .ng-dnote'), function (el) {
          var li = document.createElement('li');
          li.className = 'ng-item ng-item-foot';
          li.appendChild(el);
          rootPane.appendChild(li);
        });
        if (!dfoot.querySelector('.ng-dlinks, .ng-dnote, .ng-dloc')) dfoot.classList.add('is-empty');
      }

      if (MARK) {
        var here = window.location.pathname;
        each(levelsBox.querySelectorAll('a[href]'), function (a) {
          /* href="#" ma pathname biezacej strony - bez tego swiecilby na kazdej */
          if ((a.getAttribute('href') || '').charAt(0) === '#') return;
          if (a.pathname === here && here !== '/') a.classList.add('is-here');
        });
      }
      /* SJ szybkosc: obrazki w szufladzie podpina paint() - tylko w aktywnym panelu
         i w panelach o jeden poziom glebiej. Wczesniej mmImgsOn(levelsBox) przy
         pierwszym otwarciu pobieralo wszystkie ~160 miniaturek i logotypow naraz. */
    }

    function markOn() {
    if (MARK && nav) {
      var at = window.location.pathname;
      each(nav.querySelectorAll('.mm-tile, .mm-railbtn, .mm-blink, .mm-link'), function (a) {
        if ((a.getAttribute('href') || '#').charAt(0) === '#') return;
        if (a.pathname !== at || at === '/') return;
        a.classList.add('is-here');
        var owner = a.closest ? a.closest('.mm-l1') : null;
        if (owner) owner.classList.add('is-here');
      });
    }
    }

    /* ---------- leniwe panele menu ----------
       Zawartosc paneli nie idzie w HTML strony. Pobieramy ja raz: w tle po
       zaladowaniu strony albo od razu przy pierwszym najechaniu na menu czy
       dotknieciu przycisku szuflady. Wynik zostaje w sessionStorage, wiec
       kolejne podstrony w tej samej karcie wstawiaja panele bez zapytania. */
    var MM_URL = NGCFG().mm_url;
    var MM_KEY = 'ng-mm:' + NGCFG().mm_loc + ':' + NGCFG().mm_hour;
    var menuReady = !(nav && nav.querySelector('[data-mm-lazy]'));
    var menuLoading = false;
    var menuWait = [];

    function menuDone() {
      menuReady = true;
      promosOn();
      railsOn();
      markOn();
      each(tops, function (li) { if (li.matches(':hover')) { warm(li); warmNear(li); } });
      var q = menuWait;
      menuWait = [];
      q.forEach(function (fn) { try { fn(); } catch (e) {} });
    }

    /* Zdjecia w panelach: panel jest schowany przez visibility, wiec przegladarka
       pobieralaby je mimo loading=lazy (ok. 200 plikow na kazdej podstronie).
       Wstawiamy je z data-mm-src i podpinamy dopiero przy najechaniu na pozycje
       (warm) albo przy budowie szuflady. */
    function mmImgsOff(html) {
      return String(html).replace(/<img\b[^>]*>/g, function (tag) {
        return tag.replace(/\s(srcset|src)=/g, ' data-mm-$1=');
      });
    }

    /* SJ szybkosc3: eager = panel menu na komputerze (warm): loading=eager przed src i dekodowanie
       w tle. Szuflada na telefonie (paint) wola bez eager - jak dotad, z loading=lazy. */
    function mmImgsOn(scope, eager) {
      each(scope.querySelectorAll('img[data-mm-src]'), function (img) {
        if (eager) img.setAttribute('loading', 'eager');
        var ss = img.getAttribute('data-mm-srcset');
        if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-mm-srcset'); }
        img.setAttribute('src', img.getAttribute('data-mm-src'));
        img.removeAttribute('data-mm-src');
        if (eager && img.decode) img.decode().catch(function () {});
      });
    }

    function menuApply(map) {
      each(nav.querySelectorAll('.mm-l1[data-h] > .mm-panel[data-mm-lazy]'), function (panel) {
        var h = panel.parentNode.getAttribute('data-h');
        if (map[h] == null) return;
        panel.innerHTML = mmImgsOff(map[h]);
        panel.removeAttribute('data-mm-lazy');
      });
      menuDone();
    }

    /* Shezamme 27.10 (wlasciciel: "menu nie laduje sie od razu"): panele w localStorage (klucz: jezyk + sekcja + godzina,
       jak dotad) - nowa karta i kolejne wejscia w tej godzinie maja menu od razu, bez zapytania. Stare godziny tego jezyka
       sprzatamy przy zapisie. Gdy localStorage niedostepny (tryb prywatny, brak miejsca) - sessionStorage jak dotad. */
    function mmGet() {
      var v = null;
      try { v = window.localStorage.getItem(MM_KEY); } catch (e) {}
      if (!v) { try { v = window.sessionStorage.getItem(MM_KEY); } catch (e) {} }
      return v;
    }
    function mmSet(v) {
      try {
        var pref = 'ng-mm:' + NGCFG().mm_loc + ':', stare = [], i, k;
        for (i = 0; i < window.localStorage.length; i++) { k = window.localStorage.key(i); if (k && k.indexOf(pref) === 0 && k !== MM_KEY) stare.push(k); }
        stare.forEach(function (x) { window.localStorage.removeItem(x); });
        window.localStorage.setItem(MM_KEY, v);
        return;
      } catch (e) {}
      try { window.sessionStorage.setItem(MM_KEY, v); } catch (e) {}
    }

    function loadMenu() {
      if (menuReady || menuLoading) return;
      menuLoading = true;
      var saved = null;
      saved = mmGet();
      if (saved) {
        try { menuApply(JSON.parse(saved)); return; } catch (e) {}
      }
      var url = MM_URL + (MM_URL.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(head.id);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('mm ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var root = doc.querySelector('.mm-root');
          if (!root || root.querySelector('[data-mm-lazy]')) throw new Error('mm pusto');
          var map = {};
          each(root.querySelectorAll('.mm-l1[data-h]'), function (li) {
            for (var c = li.firstElementChild; c; c = c.nextElementSibling) {
              if (c.classList && c.classList.contains('mm-panel')) { map[li.getAttribute('data-h')] = c.innerHTML; break; }
            }
          });
          mmSet(JSON.stringify(map));
          menuApply(map);
        })
        .catch(function () {
          menuLoading = false;
          /* SJ szybkosc: gdy pelnych paneli nie da sie pobrac (blad sieci albo odpowiedz bez pelnego
             drzewa), a w HTML sa juz panele z samymi linkami (wersja lekka naglowka), menu i szuflada
             dzialaja na nich - tylko bez miniatur. Bez tego menu nie otwieraloby sie wcale. */
          var lekkie = nav ? nav.querySelectorAll('.mm-l1[data-h] > .mm-panel[data-mm-lazy]') : [];
          var pelne = lekkie.length > 0;
          each(lekkie, function (p) { if (!p.firstElementChild) pelne = false; });
          if (pelne) {
            each(lekkie, function (p) { p.removeAttribute('data-mm-lazy'); });
            menuDone();
          }
        });
    }

    function whenMenu(fn) {
      if (menuReady) { fn(); return; }
      menuWait.push(fn);
      loadMenu();
    }

    markOn();
    if (menuReady) {
      promosOn();
      railsOn();
    } else {
      var kick = function () { loadMenu(); };
      if (nav) {
        nav.addEventListener('pointerenter', kick, { once: true });
        nav.addEventListener('focusin', kick, { once: true });
      }
      /* SJ szybkosc3: pobieranie paneli rusza juz przy wejsciu kursorem w naglowek (logo, wyszukiwarka),
         a nie dopiero na pasku kategorii - zapytanie ma kilkaset ms przewagi przed pierwszym
         otwarciem panelu, wiec panelOn rzadziej czeka na whenMenu. Bez obrazkow.
         Tylko mysz/rysik: na telefonie dotkniecie naglowka (koszyk, logo) nie wstawia paneli z sessionStorage
         w trakcie tapniecia - tam pobieranie zostaje jak dotad (przycisk szuflady albo load + wolna chwila). */
      var headKick = function (e) {
        if (e && e.pointerType === 'touch') return;
        head.removeEventListener('pointerenter', headKick);
        kick();
      };
      head.addEventListener('pointerenter', headKick);
      each(head.querySelectorAll('[data-ng-open]'), function (b) {
        b.addEventListener('pointerdown', kick, { once: true });
        b.addEventListener('touchstart', kick, { once: true, passive: true });
      });
      /* Shezamme 27.10: start zaraz po zbudowaniu strony (DOMContentLoaded), a nie po 'load' (czekal na wszystkie obrazki
         i aplikacje - kilka sekund) + wolna chwila do 2,5 s. Z zapisanymi panelami to tylko wstawienie HTML. */
      var idleKick = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(kick, { timeout: 300 });
        else window.setTimeout(kick, 150);
      };
      if (document.readyState !== 'loading') idleKick();
      else document.addEventListener('DOMContentLoaded', idleKick, { once: true });
    }

    function paint() {
      var top = stack[stack.length - 1];
      levels.forEach(function (ul) {
        var id = ul.getAttribute('data-ng-pane');
        ul.classList.remove('is-active', 'is-behind');
        if (id === top) ul.classList.add('is-active');
        else if (stack.indexOf(id) > -1) ul.classList.add('is-behind');
      });
      var cur = byId[top];
      if (cur && titleEl) titleEl.textContent = cur.getAttribute('data-ng-name') || ROOT_NAME;
      if (cur) {
        mmImgsOn(cur);
        each(cur.querySelectorAll('[data-ng-goto]'), function (a) {
          var nast = byId[a.getAttribute('data-ng-goto')];
          if (nast) mmImgsOn(nast);
        });
      }
      if (backBtn) backBtn.hidden = stack.length < 2;
      cue();
    }

    function go(id) {
      var ul = byId[id];
      if (!ul || stack[stack.length - 1] === id) return;
      var parent = ul.getAttribute('data-ng-parent');
      var at2 = parent ? stack.indexOf(parent) : -1;
      if (at2 > -1) stack = stack.slice(0, at2 + 1);
      stack.push(id);
      ul.scrollTop = 0;
      paint();
    }

    function back() {
      if (stack.length < 2) return;
      stack.pop();
      paint();
    }

    var lockY = 0;

    var isLocked = false;
    var closeT = null;
    function lock(on) {
      var root = document.documentElement;
      var body = document.body;
      if (on) {
        if (isLocked) return;
        isLocked = true;
        lockY = window.pageYOffset || root.scrollTop || 0;
        var sw = window.innerWidth - root.clientWidth;
        root.classList.add('ng-locked');
        body.style.position = 'fixed';
        body.style.top = (-lockY) + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        if (sw > 0) root.style.paddingRight = sw + 'px';
      } else {
        if (!isLocked) return;
        isLocked = false;
        root.classList.remove('ng-locked');
        root.style.paddingRight = '';
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        window.scrollTo(0, lockY);
      }
    }

    function openDrawer(focusSearch) {
      if (!drawer) return;
      if (!built) {
        if (menuReady) { buildDrawer(); built = true; }
        else {
          whenMenu(function () {
            if (built) return;
            buildDrawer();
            built = true;
            stack = ['p0'];
            paint();
          });
        }
      }
      window.clearTimeout(closeT);
      lastFocus = document.activeElement;
      stack = ['p0'];
      paint();
      drawer.removeAttribute('hidden');
      void drawer.offsetWidth;
      cue();
      drawer.classList.add('is-open');
      lock(true);
      if (focusSearch && searchField) window.setTimeout(function () { searchField.focus(); }, 320);
    }

    /* Przycisk "jest tego wiecej" na dolnej krawedzi listy. */
    if (levelsBox) {
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'ng-more';
      moreBtn.setAttribute('aria-label', ALL_TXT || sjT('naglowek_wiecej', 'Wiecej'));
      moreBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>';
      moreBtn.addEventListener('click', function () {
        var pane = null;
        for (var i = 0; i < levels.length; i++) {
          if (levels[i].classList.contains('is-active')) { pane = levels[i]; break; }
        }
        if (!pane) return;
        pane.scrollTop = pane.scrollTop + Math.round(pane.clientHeight * 0.8);
        cue();
      });
      levelsBox.appendChild(moreBtn);
    }

    window.addEventListener('resize', cue);

    /* SJ 16.10: zamykanie od razu - szuflada odjezdza szybciej niz wjezdza (CSS), a odblokowanie
       przewijania (przestawienie body + scrollTo = przeliczenie calej strony) dopiero po animacji,
       zeby nie hamowalo jej startu na telefonie. */
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      window.clearTimeout(closeT);
      closeT = window.setTimeout(function () {
        if (drawer.classList.contains('is-open')) return;
        drawer.setAttribute('hidden', '');
        lock(false);
      }, 230);
      each(head.querySelectorAll('[data-ng-open]'), function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
    }

    each(head.querySelectorAll('[data-ng-open]'), function (btn) {
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-expanded', 'true');
        openDrawer(btn.getAttribute('data-ng-open') === 'search');
      });
    });
    if (backBtn) backBtn.addEventListener('click', back);
    each(head.querySelectorAll('[data-ng-close]'), function (b) { b.addEventListener('click', closeDrawer); });

    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hasAttribute('hidden')) return;
      if (e.key === 'Escape') { if (stack.length > 1) { back(); } else { closeDrawer(); } }
      if (e.key === 'Tab') {
        var shell = drawer.querySelector('.ng-shell');
        if (!shell) return;
        var all = [];
        each(shell.querySelectorAll('a[href], button, input, select'), function (n) {
          if (n.disabled || n.hidden || n.type === 'hidden' || n.offsetParent === null) return;
          var pane = n.closest ? n.closest('.ng-pane') : null;
          if (pane && !pane.classList.contains('is-active')) return;
          all.push(n);
        });
        if (!all.length) return;
        var first = all[0];
        var last = all[all.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    if (wide.addEventListener) {
      wide.addEventListener('change', function () {
        if (wide.matches && drawer && !drawer.hasAttribute('hidden')) closeDrawer();
        if (!wide.matches) panelsOff();
      });
    }
    /* ---------- przyklejony naglowek ---------- */
    /* motyw uzywa --header_height w wielu sekcjach (przyklejona karta produktu,
       pasek kolekcji, kotwice galerii), ale zaden aktywny naglowek jej nie ustawial.
       Liczymy ja z realnej wysokosci przyklejonej sekcji naglowka. */
    var stickyWrap = head.parentElement;
    var lastH = -1;
    function setHeadVar() {
      if (!stickyWrap) return;
      var sticky = getComputedStyle(stickyWrap).position === 'sticky';
      var h = sticky ? Math.round(stickyWrap.getBoundingClientRect().height) : 0;
      if (h === lastH) return;
      lastH = h;
      document.documentElement.style.setProperty('--header_height', h + 'px');
    }

    /* SJ szybkosc3: wysokosc naglowka liczy ResizeObserver - jego wywolanie przychodzi po ulozeniu strony
       (przed narysowaniem klatki), wiec odczyt nic nie wymusza. Wczesniej setHeadVar() przy starcie i w kazdym
       zdarzeniu scroll czytalo getComputedStyle + getBoundingClientRect w trakcie wczytywania strony:
       Lighthouse "Forced reflow" 20-120 ms na stronie (maks-naglowek.js), w dlugim zadaniu skryptow defer.
       Observer lapie tez zmiane wysokosci po doczytaniu fontow. Bez ResizeObserver - stara sciezka. */
    var headRO = null;
    var onScroll = function () {
      if (head.classList.contains('ng-sticky')) head.classList.toggle('is-stuck', window.scrollY > 2);
      if (!headRO) setHeadVar();
    };
    if (stickyWrap && typeof ResizeObserver === 'function') {
      var roFirst = true;
      headRO = new ResizeObserver(function () {
        setHeadVar();
        if (roFirst) { roFirst = false; onScroll(); }
      });
      headRO.observe(stickyWrap);
    } else {
      setHeadVar();
      window.addEventListener('load', setHeadVar);
      onScroll();
    }
    window.addEventListener('resize', setHeadVar, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('shopify:section:unload', function off(e) {
      if (e.target !== head && !e.target.contains(head)) return;
      window.removeEventListener('scroll', onScroll);
      if (headRO) headRO.disconnect();
      document.removeEventListener('shopify:section:unload', off);
    });

    /* ---------- licznik koszyka ---------- */
    var countEl = head.querySelector('[data-ng-count]');
    if (countEl) {
      /* SJ 16.10: kwota w pigulce koszyka (ustawienie cart_pill). Po zmianie
         licznika dociagamy sama kwote z sekcji sj-koszyk-suma - ten sam format
         co w Liquid, takze przy innej walucie. */
      var sumEl = head.querySelector('[data-ng-sum]');
      var lastN = null;
      var syncSum = function () {
        if (!sumEl || typeof fetch !== 'function' || typeof DOMParser !== 'function') return;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + '?section_id=sj-koszyk-suma', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var v = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sj-suma]');
            var t = v ? (v.textContent || '').replace(/^\s+|\s+$/g, '') : '';
            if (t) sumEl.textContent = t;
          })
          .catch(function () {});
      };
      var syncCount = function () {
        var n = parseInt((countEl.textContent || '').replace(/[^0-9]/g, ''), 10);
        if (!(n > 0)) n = 0;
        countEl.classList.toggle('is-zero', !(n > 0));
        if (lastN !== null && n !== lastN) syncSum();
        lastN = n;
      };
      syncCount();
      if (typeof MutationObserver === 'function') {
        new MutationObserver(syncCount).observe(countEl, { childList: true, characterData: true, subtree: true });
      }
    }

    /* ---------- waluta i jezyk ---------- */
    var KARETKA = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>';
    /* SJ 25.10: flagi przy jezykach (wlasciciel "w jezykach daj flagi"). Wlasne proste SVG 3:2 (bez obrazkow z zewnatrz),
       klucz = kod jezyka sklepu; EN = Wielka Brytania. Tylko lista jezykow (locale_code), nie waluty. */
    var FL3 = function (a, b, c, pion) {
      return pion
        ? '<rect width="10" height="20" fill="' + a + '"/><rect x="10" width="10" height="20" fill="' + b + '"/><rect x="20" width="10" height="20" fill="' + c + '"/>'
        : '<rect width="30" height="7" fill="' + a + '"/><rect y="6.6" width="30" height="7" fill="' + b + '"/><rect y="13.3" width="30" height="6.7" fill="' + c + '"/>';
    };
    var FLAGI = {
      pl: '<rect width="30" height="10" fill="#fff"/><rect y="10" width="30" height="10" fill="#DC143C"/>',
      de: FL3('#000', '#DD0000', '#FFCE00'),
      en: '<rect width="30" height="20" fill="#012169"/><path d="M0 0L30 20M30 0L0 20" stroke="#fff" stroke-width="4"/><path d="M0 0L30 20M30 0L0 20" stroke="#C8102E" stroke-width="1.6"/><path d="M15 0V20M0 10H30" stroke="#fff" stroke-width="6"/><path d="M15 0V20M0 10H30" stroke="#C8102E" stroke-width="3.4"/>',
      uk: '<rect width="30" height="10" fill="#0057B7"/><rect y="10" width="30" height="10" fill="#FFD700"/>',
      cs: '<rect width="30" height="10" fill="#fff"/><rect y="10" width="30" height="10" fill="#D7141A"/><path d="M0 0L15 10L0 20Z" fill="#11457E"/>',
      fr: FL3('#002654', '#fff', '#CE1126', true),
      it: FL3('#009246', '#fff', '#CE2B37', true),
      es: '<rect width="30" height="20" fill="#AA151B"/><rect y="5" width="30" height="10" fill="#F1BF00"/>',
      'pt-pt': '<rect width="30" height="20" fill="#DA291C"/><rect width="12" height="20" fill="#046A38"/><circle cx="12" cy="10" r="3.6" fill="#FFE900"/>',
      ru: FL3('#fff', '#0039A6', '#D52B1E'),
      hi: FL3('#FF9933', '#fff', '#138808') + '<circle cx="15" cy="10" r="2.4" fill="none" stroke="#000080" stroke-width=".8"/>'
    };
    var flaga = function (kod) {
      var f = FLAGI[String(kod || '').toLowerCase()];
      return f ? '<span class="ng-flag" aria-hidden="true"><svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" focusable="false">' + f + '</svg></span>' : '';
    };
    each(head.querySelectorAll('form.ng-locform'), function (form) {
      var sel = form.querySelector('select');
      if (!sel) return;
      form.classList.add('is-ready');
      var wyslij = function () { sjPrzedZmiana(form); form.submit(); };
      sel.addEventListener('change', wyslij);

      var opcje = sel.options;
      if (!opcje || opcje.length < 2) return;
      form.classList.add('ng-loc-js');

      var trig = document.createElement('button');
      trig.type = 'button';
      trig.className = 'ng-loctrig';
      trig.setAttribute('aria-haspopup', 'listbox');
      trig.setAttribute('aria-expanded', 'false');
      var etykieta = sel.getAttribute('aria-label');
      if (etykieta) trig.setAttribute('aria-label', etykieta);
      var jezyki = sel.name === 'locale_code';
      if (jezyki) form.classList.add('ng-loc-flagi');
      trig.innerHTML = (jezyki && opcje[sel.selectedIndex] ? flaga(opcje[sel.selectedIndex].value) : '') + '<span class="ng-loctxt">' + esc(opcje[sel.selectedIndex] ? opcje[sel.selectedIndex].text : '') + '</span>' + KARETKA;

      var menu = document.createElement('ul');
      menu.className = 'ng-locmenu';
      menu.setAttribute('role', 'listbox');
      for (var i = 0; i < opcje.length; i++) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ng-locopt';
        b.setAttribute('role', 'option');
        b.setAttribute('data-i', String(i));
        if (i === sel.selectedIndex) b.setAttribute('aria-current', 'true');
        if (jezyki) { b.innerHTML = flaga(opcje[i].value) + '<span>' + esc(opcje[i].text) + '</span>'; } else { b.textContent = opcje[i].text; }
        li.appendChild(b);
        menu.appendChild(li);
      }
      form.insertBefore(trig, sel);
      form.appendChild(menu);

      function zamknij() {
        form.classList.remove('is-open');
        trig.setAttribute('aria-expanded', 'false');
      }
      function przelacz() {
        var byl = form.classList.contains('is-open');
        each(head.querySelectorAll('form.ng-locform.is-open'), function (f) {
          f.classList.remove('is-open');
          var t = f.querySelector('.ng-loctrig');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!byl) {
          form.classList.add('is-open');
          trig.setAttribute('aria-expanded', 'true');
        }
      }
      trig.addEventListener('click', function (e) { e.preventDefault(); przelacz(); });
      menu.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.ng-locopt') : null;
        if (!b) return;
        e.preventDefault();
        var i = parseInt(b.getAttribute('data-i'), 10);
        if (isNaN(i) || i === sel.selectedIndex) { zamknij(); return; }
        sel.selectedIndex = i;
        zamknij();
        wyslij();
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) zamknij();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') zamknij();
      });
    });
  };

  var boot = function (scope) {
    each((scope || document).querySelectorAll('[data-ng-head]'), function (n) { init(n); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
}());
;/* Normalizacja zapytan wyszukiwarki.
   Domyslnie Shopify przeszukuje takze opisy, wiec "buty jordan" zwracalo ~1000 wynikow
   (slowo "buty" wystepuje w opisie kazdego buta). Zamieniamy polskie nazwy kategorii
   na filtr product_type, a reszte slow zawezamy do tytulu produktu. */
(function () {
    var TYP = {
        'buty': 'Buty', 'but': 'Buty', 'obuwie': 'Buty', 'sneakersy': 'Buty', 'sneakers': 'Buty', 'sneakersow': 'Buty',
        'koszulka': 'Koszulki', 'koszulki': 'Koszulki', 'koszulke': 'Koszulki', 'tshirt': 'Koszulki', 't-shirt': 'Koszulki',
        'bluza': 'Bluzy', 'bluzy': 'Bluzy', 'bluze': 'Bluzy', 'hoodie': 'Bluzy',
        'spodnie': 'Spodnie', 'spodni': 'Spodnie',
        'kurtka': 'Kurtki', 'kurtki': 'Kurtki', 'kurtke': 'Kurtki',
        'zestaw': 'Zestawy', 'zestawy': 'Zestawy',
        'akcesoria': 'Akcesoria', 'akcesorium': 'Akcesoria',
        'naklejki': 'Naklejki Streetwear', 'naklejka': 'Naklejki Streetwear',
        'obraz': 'Obrazy Streetwear', 'obrazy': 'Obrazy Streetwear'
    };
    /* SJ 18.10: w innych jezykach typ produktu jest przetlumaczony (Bluzy -> Hoodies), wiec filtr product_type:"Bluzy"
       w /en/ dawal zero podpowiedzi. TYP_LOK = nazwa typu w jezyku sklepu (z tlumacz/slowniki/slownik.csv - ten sam slownik,
       ktorym tlumaczony jest product_type), TYP_SLOWA = nazwy typow z innych jezykow jako slowa szukania. */
    var TYP_LOK = {"en":{"Buty":"Shoes","Koszulki":"T-shirts","Bluzy":"Hoodies","Spodnie":"Pants","Kurtki":"Jackets","Akcesoria":"Accessories","Zestawy":"Sets","Obrazy Streetwear":"Streetwear Canvas Art","Naklejki Streetwear":"Streetwear Stickers"},"de":{"Buty":"Schuhe","Koszulki":"T-Shirts","Bluzy":"Hoodies","Spodnie":"Hosen","Kurtki":"Jacken","Akcesoria":"Accessoires","Zestawy":"Sets","Obrazy Streetwear":"Streetwear-Bilder","Naklejki Streetwear":"Streetwear-Sticker"},"uk":{"Buty":"Взуття","Koszulki":"Футболки","Bluzy":"Худі","Spodnie":"Штани","Kurtki":"Куртки","Akcesoria":"Аксесуари","Zestawy":"Комплекти","Obrazy Streetwear":"Стрітвір-картини","Naklejki Streetwear":"Стрітвір-наліпки"},"cs":{"Buty":"Boty","Koszulki":"Trička","Bluzy":"Mikiny","Spodnie":"Kalhoty","Kurtki":"Bundy","Akcesoria":"Doplňky","Zestawy":"Sety","Obrazy Streetwear":"Streetwear obrazy","Naklejki Streetwear":"Streetwear samolepky"},"fr":{"Buty":"Chaussures","Koszulki":"T-shirts","Bluzy":"Sweats","Spodnie":"Pantalons","Kurtki":"Vestes","Akcesoria":"Accessoires","Zestawy":"Ensembles","Obrazy Streetwear":"Tableaux streetwear","Naklejki Streetwear":"Autocollants streetwear"},"it":{"Buty":"Scarpe","Koszulki":"T-shirt","Bluzy":"Felpe","Spodnie":"Pantaloni","Kurtki":"Giacche","Akcesoria":"Accessori","Zestawy":"Set","Obrazy Streetwear":"Quadri streetwear","Naklejki Streetwear":"Adesivi streetwear"},"es":{"Buty":"Zapatillas","Koszulki":"Camisetas","Bluzy":"Sudaderas","Spodnie":"Pantalones","Kurtki":"Chaquetas","Akcesoria":"Accesorios","Zestawy":"Conjuntos","Obrazy Streetwear":"Cuadros streetwear","Naklejki Streetwear":"Pegatinas streetwear"},"pt-PT":{"Buty":"Sapatilhas","Koszulki":"T-shirts","Bluzy":"Sweatshirts","Spodnie":"Calças","Kurtki":"Casacos","Akcesoria":"Acessórios","Zestawy":"Conjuntos","Obrazy Streetwear":"Quadros streetwear","Naklejki Streetwear":"Autocolantes streetwear"},"ru":{"Buty":"Обувь","Koszulki":"Футболки","Bluzy":"Худи","Spodnie":"Брюки","Kurtki":"Куртки","Akcesoria":"Аксессуары","Zestawy":"Комплекты","Obrazy Streetwear":"Стритвир-картины","Naklejki Streetwear":"Стритвир-наклейки"},"hi":{"Buty":"जूते","Koszulki":"टी-शर्ट","Bluzy":"हुडी","Spodnie":"पैंट","Kurtki":"जैकेट","Akcesoria":"एक्सेसरीज़","Zestawy":"सेट","Obrazy Streetwear":"स्ट्रीटवियर पेंटिंग्स","Naklejki Streetwear":"स्ट्रीटवियर स्टिकर"}};
    var TYP_SLOWA = {"shoes":"Buty","schuhe":"Buty","взуття":"Buty","boty":"Buty","chaussures":"Buty","scarpe":"Buty","zapatillas":"Buty","sapatilhas":"Buty","обувь":"Buty","जूते":"Buty","t-shirts":"Koszulki","футболки":"Koszulki","trička":"Koszulki","t-shirt":"Koszulki","camisetas":"Koszulki","टी-शर्ट":"Koszulki","hoodies":"Bluzy","худі":"Bluzy","mikiny":"Bluzy","sweats":"Bluzy","felpe":"Bluzy","sudaderas":"Bluzy","sweatshirts":"Bluzy","худи":"Bluzy","हुडी":"Bluzy","pants":"Spodnie","hosen":"Spodnie","штани":"Spodnie","kalhoty":"Spodnie","pantalons":"Spodnie","pantaloni":"Spodnie","pantalones":"Spodnie","calças":"Spodnie","брюки":"Spodnie","पैंट":"Spodnie","jackets":"Kurtki","jacken":"Kurtki","куртки":"Kurtki","bundy":"Kurtki","vestes":"Kurtki","giacche":"Kurtki","chaquetas":"Kurtki","casacos":"Kurtki","जैकेट":"Kurtki","accessories":"Akcesoria","accessoires":"Akcesoria","аксесуари":"Akcesoria","doplňky":"Akcesoria","accessori":"Akcesoria","accesorios":"Akcesoria","acessórios":"Akcesoria","аксессуары":"Akcesoria","एक्सेसरीज़":"Akcesoria","sets":"Zestawy","комплекти":"Zestawy","sety":"Zestawy","ensembles":"Zestawy","set":"Zestawy","conjuntos":"Zestawy","комплекты":"Zestawy","सेट":"Zestawy","streetwear-bilder":"Obrazy Streetwear","стрітвір-картини":"Obrazy Streetwear","стритвир-картины":"Obrazy Streetwear","streetwear-sticker":"Naklejki Streetwear","стрітвір-наліпки":"Naklejki Streetwear","стритвир-наклейки":"Naklejki Streetwear"};
    for (var tsw in TYP_SLOWA) if (!TYP[tsw]) TYP[tsw] = TYP_SLOWA[tsw];
    function typLok(t) {
        var l = String((typeof NGCFG === 'function' && NGCFG().loc) || 'pl');
        /* Shezamme 27.10: typ produktu w wyszukiwaniu Shezamme jest zawsze polski (Buty, Bluzy) - bez tlumaczenia,
           inaczej w /en/ /de/ podpowiedzi z typem ("hoodie", "jordan shoes") dawaly 0 wynikow. */
        return t;
    }

    /* SJ 16.10: takze poczatek slowa - przy pisaniu "essentials koszul" podpowiedzi byly puste, bo
       niedokonczone "koszul" szlo jako slowo z tytulu (tytuly sa po angielsku). Ostatnie, wlasnie
       pisane slowo od 3 liter, pozostale od 4; tylko gdy poczatek pasuje do jednego typu. */
    function typDla(w, ostatnie) {
        if (TYP[w]) return TYP[w];
        if (w.length < (ostatnie ? 3 : 4)) return null;
        var hit = null;
        for (var k in TYP) {
            if (k.indexOf(w) === 0) {
                if (hit && hit !== TYP[k]) return null;
                hit = TYP[k];
            }
        }
        return hit;
    }

    function build(raw) {
        var term = String(raw == null ? '' : raw).replace(/^\s+|\s+$/g, '');
        if (!term) return '';
        // zapytanie skladniowe uzytkownika zostawiamy w spokoju
        if (term.indexOf(':') > -1 || term.indexOf('"') > -1) return term;
        /* kod produktu (JI4395, 1135092-LBNZ) nigdy nie siedzi w tytule, wiec
           zawezenie do title: zabijalo takie szukanie - puszczamy je surowo */
        if (/^[a-z0-9][a-z0-9._\/-]*$/i.test(term) && /\d/.test(term) && term.length >= 4) return term;

        var words = term.toLowerCase().replace(/[(){}\[\]"']/g, ' ').split(/\s+/).filter(function (w) { return !!w; });
        var types = [], rest = [];
        words.forEach(function (w, i) {
            var t = typDla(w, i === words.length - 1);
            if (t) { if (types.indexOf(t) < 0) types.push(t); }
            else rest.push(w);
        });
        if (!types.length && !rest.length) return term;

        /* SJ 25.10: slowa BEZ 'title:' - pole z prefiksem dopasowuje tylko cale slowa ("myste" i "jord" dawaly
           "Brak wynikow", "mystery" i "jordan" dzialaly). Podpowiedzi Shopify i tak nie szukaja w opisach
           (domyslnie: tytul, typ, marka, SKU), a resources[options][prefix]=last dopasowuje poczatek ostatniego slowa. */
        var frag = [];
        types.forEach(function (t) { frag.push('product_type:"' + typLok(t) + '"'); });
        if (rest.length) frag.push(rest.join(' '));
        return frag.join(' AND ');
    }

    function target(raw) {
        /* SJ 16.10: na stronie wynikow fraza zostaje taka, jak ja wpisal klient
           (wczesniej q dostawalo "title:... AND NOT tag:kids" i ta skladnia pokazywala
           sie w polu wyszukiwarki). Precyzje daje ograniczenie pol wyszukiwania. */
        var q = String(raw == null ? '' : raw).replace(/^\s+|\s+$/g, '');
        return NGCFG().search_url +
            '?q=' + encodeURIComponent(q) +
            '&type=product&options%5Bprefix%5D=last' +
            '&options%5Bfields%5D=title%2Cproduct_type%2Cvendor%2Cvariants.sku%2Ctag';
    }

    window.ngSearchQuery = build;
    window.ngSearchUrl = target;

    /* SJ 16.10: Enter z sama nazwa marki albo kategorii prowadzi od razu na jej strone
       (wlasciciel: "jak wpisuje nazwe i Enter to jest zla kategoria"). Znane kolekcje (tytul -> adres)
       zbieraja podpowiedzi w naglowku i nakladka szukania (assets/maks-szukajka.js): kolekcje z odpowiedzi
       podpowiedzi, popularne zapytania z adresem kategorii i kafelki marek. Porownanie bez wielkosci liter,
       ogonkow i znakow miedzy slowami ("off white" = "Off-White"). Bez trafienia - zwykle wyniki jak dotad.
       Strona wynikow sama tez przenosi na kolekcje o uchwycie rownym frazie (sections/maks-kolekcja.liquid),
       tu jest tylko skrot bez tego przeladowania. */
    var KOL = {};
    function kolNorm(s) {
        var t = String(s == null ? '' : s).toLowerCase().replace(/\u0142/g, 'l');
        if (t.normalize) t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return t.replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, '');
    }
    window.sjKolZnane = function (lista) {
        (lista || []).forEach(function (c) {
            if (!c) return;
            var n = kolNorm(c.title);
            var u = kolCzysc(String(c.url || ''));
            /* tylko adres w sklepie: "/..." bez "//" i "/\" (adres wzgledny protokolu prowadzi na inna domene) */
            if (!n || kolUrl(n) || !/^\/[^\/\\]/.test(u) || u.indexOf('/collections/') < 0) return;
            KOL[n] = u;
        });
    };
    /* SJ 16.10: adresy kolekcji z podpowiedzi Shopify maja parametry sledzace (_pos, _psq, _ss, _v, _sid) - na stronie
       kategorii przechodzilyby do linkow filtrow, sortowania i adresu w pasku. Wycinamy tylko je; reszta adresu
       (np. filtry w popularnych zapytaniach) zostaje bez zmian. */
    function kolCzysc(u) {
        if (!/[?&]_(pos|psq|ss|v|sid)=/.test(u)) return u;
        var h = u.indexOf('#'), hash = h > -1 ? u.slice(h) : '';
        if (h > -1) u = u.slice(0, h);
        var q = u.indexOf('?');
        if (q < 0) return u + hash;
        var p = u.slice(q + 1).split('&').filter(function (x) { return x && !/^_(pos|psq|ss|v|sid)=/.test(x); });
        return u.slice(0, q) + (p.length ? '?' + p.join('&') : '') + hash;
    }
    function kolUrl(n) {
        return Object.prototype.hasOwnProperty.call(KOL, n) ? KOL[n] : '';
    }

    function wire(form) {
        if (!form || form.getAttribute('data-ng-q') === '1') return;
        form.setAttribute('data-ng-q', '1');
        form.addEventListener('submit', function (e) {
            var field = form.querySelector('input[name="q"]');
            if (!field) return;
            var raw = field.value.replace(/^\s+|\s+$/g, '');
            if (!raw) return;
            e.preventDefault();
            window.location.href = kolUrl(kolNorm(raw)) || target(raw);
        });
    }

    function init() {
        /* wszystkie formularze szukania na stronie: naglowek, szuflada,
           pole doprecyzowania na stronie wynikow i formularz przy braku wynikow.
           Pomijamy wyszukiwanie po artykulach (blog) - tam zawezanie do title nie ma sensu. */
        document.querySelectorAll('form[role="search"]').forEach(function (form) {
            if (!form.querySelector('input[name="q"]')) return;
            var typ = form.querySelector('input[name="type"]');
            if (typ && typ.value && typ.value !== 'product') return;
            wire(form);
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
})();
;(function(){ if (!NGCFG().sug_on) return;

(function () {
    var host = document.getElementById(NGCFG().sid);
    if (!host) return;
    if (host.getAttribute('data-ng-sug-on') === '1') return;
    host.setAttribute('data-ng-sug-on', '1');
    var panels = [];
    host.querySelectorAll('[data-ng-sug]').forEach(function (n) { panels.push(n); });
    if (!panels.length) return;

    var drawer = host.querySelector('[data-ng-drawer]');
    var LIMIT = NGCFG().sug_limit;
    var COLL = NGCFG().sug_coll;
    var MIN = 2;
    var LOC = NGCFG().loc;
    var CUR = NGCFG().cur;
    var T_PROD = NGCFG().t_prod;
    var T_COLL = NGCFG().t_coll;
    var T_ALL = NGCFG().t_all;

    function scoped(t) {
        return (typeof window.ngSearchQuery === 'function') ? window.ngSearchQuery(t) : t;
    }
    function allUrl(t) {
        if (typeof window.ngSearchUrl === 'function') return window.ngSearchUrl(t);
        return SEARCH + '?q=' + encodeURIComponent(t) + '&type=product&options%5Bprefix%5D=last';
    }
    var T_EMPTY = NGCFG().t_empty;
    var T_WAIT = NGCFG().t_wait;
    var T_FROM = NGCFG().t_from;
    var BASE = NGCFG().pred_url;
    var SEARCH = NGCFG().search_url;
    /* SJ 16.10: puste pole -> "Popularne zapytania" jak na WordPressie */
    var POP = String(NGCFG().pop || '').split(',').map(function (x) { return x.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
    /* SJ 18.10: adresy z ustawienia (Essentials=/collections/essentials) sa bez prefiksu jezyka - w /de/ chip i Enter
       prowadzily na polska wersje. Dokladamy routes.root_url (cfg.root, np. "/de"), gdy adresu jeszcze go nie ma. */
    var ROOT = String(NGCFG().root || '/');
    function lok(u) {
        if (ROOT === '/' || !/^\/[^\/\\]/.test(u) || u === ROOT || u.indexOf(ROOT + '/') === 0) return u;
        return ROOT + u;
    }
    var T_POP = NGCFG().t_pop || '';
    /* SJ 16.10: popularne zapytania z adresem kategorii ("Essentials=/collections/essentials") tez do skrotu Enter -> kategoria */
    if (window.sjKolZnane) window.sjKolZnane(POP.map(function (t) {
        var i = t.indexOf('=');
        return i > 0 ? { title: t.slice(0, i), url: lok(t.slice(i + 1).replace(/^\s+/, '')) } : null;
    }));

    function esc(v) {
        return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function money(v) {
        var n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.,-]/g, '').replace(/\s/g, '').replace(',', '.'));
        if (!isFinite(n)) return '';
        try {
            /* Sama liczba plus waluta z tylu - styl 'currency' przy angielskiej
               lokalizacji dawal 'PLN 879' zamiast '879 PLN'. */
            return new Intl.NumberFormat(LOC, {
                minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
            }).format(n) + ' ' + CUR;
        } catch (e) {
            return String(Math.round(n)) + ' ' + CUR;
        }
    }

    function rowHtml(p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var thumb = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var lo = money(p.price_min || p.price);
        var hi = money(p.price_max || p.price);
        var price = lo && hi && lo !== hi ? T_FROM + ' ' + lo : lo;
        return '<li><a class="ng-sug-row" href="' + esc(p.url) + '">'
            + '<span class="ng-sug-media">' + (thumb ? '<img src="' + esc(thumb) + '" alt="" loading="lazy" width="200" height="200">' : '') + '</span>'
            + '<span class="ng-sug-txt">'
            + (p.vendor ? '<span class="ng-sug-vendor">' + esc(p.vendor) + '</span>' : '')
            + '<span class="ng-sug-name">' + esc(p.title) + '</span>'
            + (price ? '<span class="ng-sug-price">' + esc(price) + '</span>' : '')
            + '</span></a></li>';
    }


    /* Produkty dzieciece maja tag "kids", a kolekcje handle z "kids" albo "dla-dzieci".
       W podpowiedziach odsiewamy je po stronie przegladarki, bo dopisanie
       "NOT tag:kids" do zapytania psuje dopasowanie po przedrostku
       (wpisane "ni" przestaje znajdowac Nike). */
    function bezDzieci(lista) {
        return (lista || []).filter(function (x) {
            var t = x.tags || [];
            for (var i = 0; i < t.length; i++) {
                if (String(t[i]).toLowerCase() === 'kids') return false;
            }
            return true;
        });
    }
    /* SJ 16.10: w podpowiedziach tylko MARKI (wlasciciel: "usun kategorie, zostaw same marki").
       Wszystkie kolekcje sklepu to reguly kat:<uchwyt>; kategorie maja uchwyt zaczynajacy sie od
       nazwy rodzaju (buty, bluzy-supreme, czapki-..., figurki-...), marki/modele - od marki. */
    var KAT_RE = /^(akcesoria|bielizna|bluzy|bokserki|buty|czapki|figurki|inne|karty-podarunkowe|kids|koszulki|ksiazki|kurtki|nowosci|obrazy|okazje|pielegnacja-butow|spodnie|sznurowki|ubrania|zestaw|zestawy|frontpage|hype-grail|mysterybox-streetwear|szorty|skarpetki|torby|plecaki|portfele|okulary|naklejki|bestsellery|wyprzedaz|promocje|polecane)(-|$)/;
    function bezDzieciKol(lista) {
        return (lista || []).filter(function (x) {
            var s = (String(x.handle || '') + ' ' + String(x.url || '') + ' ' + String(x.title || '')).toLowerCase();
            var h = String(x.handle || String(x.url || '').split('?')[0].split('/').pop() || '').toLowerCase();
            return s.indexOf('kids') < 0 && s.indexOf('dla-dzieci') < 0 && s.indexOf('dla dzieci') < 0 && !KAT_RE.test(h);
        });
    }

    function render(box, data, term) {
        var r = (data && data.resources && data.resources.results) || {};
        /* SJ 16.10: kolekcje z odpowiedzi (takze te nie pokazane jako Marki) do skrotu Enter -> kategoria */
        if (window.sjKolZnane) window.sjKolZnane(r.collections);
        var prods = bezDzieci(r.products);
        var colls = COLL ? bezDzieciKol(r.collections) : [];
        var html = '';
        if (colls.length) {
            html += '<span class="ng-sug-head">' + esc(T_COLL) + '</span><div class="ng-sug-chips">';
            colls.forEach(function (c) {
                html += '<a class="ng-sug-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
            });
            html += '</div>';
        }
        if (prods.length) {
            html += '<span class="ng-sug-head">' + esc(T_PROD) + '</span><ul class="ng-sug-list">';
            prods.forEach(function (p) { html += rowHtml(p); });
            html += '</ul>';
        }
        if (!prods.length && !colls.length) {
            html += '<span class="ng-sug-empty">' + esc(T_EMPTY) + '</span>';
        } else {
            /* SJ 16.10: "Zobacz wszystkie wyniki" ma pokazac wyniki - sort_by=relevance (domyslna kolejnosc) wylacza
               przejscie na kategorie o tej samej nazwie (sections/maks-kolekcja.liquid). Enter przechodzi jak dotad. */
            html += '<a class="ng-sug-all" href="' + esc(allUrl(term) + '&sort_by=relevance') + '"><span>' + esc(T_ALL) + '</span><span aria-hidden="true">&rsaquo;</span></a>';
        }
        box.innerHTML = html;
        show(box);
    }

    function renderPop(box) {
        if (!POP.length) { hide(box); return; }
        var html = '<span class="ng-sug-head">' + esc(T_POP) + '</span><div class="ng-sug-chips ng-sug-pop">';
        /* SJ 16.10: pozycja "Etykieta=/collections/uchwyt" prowadzi prosto na strone kategorii
           (wyglad, filtry i sortowanie jak w kolekcjach), sama etykieta - do wynikow wyszukiwania. */
        POP.forEach(function (t) {
            var i = t.indexOf('='), lbl = i > 0 ? t.slice(0, i).replace(/\s+$/, '') : t, url = i > 0 ? t.slice(i + 1).replace(/^\s+/, '') : '';
            if (!/^\/[^\/]/.test(url)) url = allUrl(lbl);
            else url = lok(url);
            html += '<a class="ng-sug-chip" href="' + esc(url) + '">' + esc(lbl) + '</a>';
        });
        box.innerHTML = html + '</div>';
        show(box);
    }

    function show(box) {
        box.hidden = false;
        if (drawer && box.classList.contains('ng-dsug')) drawer.classList.add('is-searching');
    }

    function hide(box) {
        box.hidden = true;
        box.innerHTML = '';
        if (drawer && box.classList.contains('ng-dsug')) drawer.classList.remove('is-searching');
    }

    panels.forEach(function (box) {
        var form = box.classList.contains('ng-dsug') ? box.previousElementSibling : box.closest('form');
        if (!form) return;
        var field = form.querySelector('input[name="q"]');
        if (!field) return;

        var timer = null;
        var ctrl = null;
        var cursor = -1;

        function items() { return box.querySelectorAll('a'); }

        function move(step) {
            var list = items();
            if (!list.length) return;
            if (cursor >= 0 && list[cursor]) list[cursor].classList.remove('is-on');
            cursor = (cursor + step + list.length + 2) % (list.length + 1) - 1;
            if (cursor < 0) { field.focus(); return; }
            list[cursor].classList.add('is-on');
            list[cursor].scrollIntoView({ block: 'nearest' });
        }

        function ask() {
            var term = field.value.replace(/^\s+|\s+$/g, '');
            cursor = -1;
            if (term.length < MIN) { if (ctrl) ctrl.abort(); if (!term.length) { renderPop(box); } else { hide(box); } return; }
            if (ctrl) ctrl.abort();
            ctrl = typeof AbortController === 'function' ? new AbortController() : null;
            box.innerHTML = '<span class="ng-sug-wait">' + esc(T_WAIT) + '</span>';
            show(box);
            var url = BASE + '.json?q=' + encodeURIComponent(scoped(term))
                + '&resources[type]=' + (COLL ? 'product,collection' : 'product')
                + '&resources[limit]=' + LIMIT
                + '&resources[options][unavailable_products]=last'
                + '&resources[options][prefix]=last';
            fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
                .then(function (res) { return res.json(); })
                .then(function (data) {
                    if (field.value.replace(/^\s+|\s+$/g, '') !== term) return;
                    render(box, data, term);
                })
                .catch(function (err) {
                    if (err && err.name === 'AbortError') return;
                    hide(box);
                });
        }

        field.addEventListener('input', function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(ask, 220);
        });

        field.addEventListener('focus', function () {
            var t = field.value.replace(/^\s+|\s+$/g, '');
            if (!t.length) { renderPop(box); return; }
            if (t.length >= MIN && box.innerHTML) show(box);
        });
        field.addEventListener('click', function () {
            if (!field.value.replace(/^\s+|\s+$/g, '').length && box.hidden) renderPop(box);
        });

        field.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
            else if (e.key === 'Enter' && cursor >= 0 && !box.hidden) {
                var list = items();
                if (list[cursor] && list[cursor].href) { e.preventDefault(); window.location.href = list[cursor].href; }
            }
            else if (e.key === 'Escape' && !box.hidden) { e.stopPropagation(); hide(box); }
        });

        box.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
            else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
            else if (e.key === 'Escape') { e.stopPropagation(); hide(box); field.focus(); }
        });

        form.addEventListener('submit', function () { hide(box); });

        document.addEventListener('click', function (e) {
            if (box.hidden) return;
            if (form.contains(e.target) || box.contains(e.target)) return;
            hide(box);
        });
    });
})();

})();
